import { AiOutlineHome } from "react-icons/ai";
import { BsChevronDown } from "react-icons/bs";
import { UserOutlined } from "@ant-design/icons";
import { CiWallet } from "react-icons/ci";

export const URL = {
  home: "/",
  signin: "/signin",

  // bailiff detail.
  dialog: "/bailiff/:bailiffId",

  //wallet
  wallet: "/wallet",

  //
  system: "system",
  dev: "/dev",
};

// -------------------------- ITEM MAPPING --------------------------
export const newItems = () => {
  const items = {
    home: {
      title: "Dashboard",
      url: URL.home,
      key: "1",
      hightlight: ["1"],
      require: [],
      arrow: false,
      icon: <AiOutlineHome />,
    },
    dashboard: {
      title: "Danh sách nhân viên",
      url: URL.home,
      key: "1",
      hightlight: ["1"],
      require: [],
      arrow: false,
      icon: <UserOutlined />,
    },
    wallet: {
      title: "Ví tiền",
      url: URL.wallet,
      key: "2",
      hightlight: ["2"],
      require: [],
      arrow: false,
      icon: <CiWallet />,
    },
    login: {
      title: "Đăng nhập",
      url: URL.home,
      key: "1",
      hightlight: ["1"],
      require: [],
      arrow: false,
    },
  };
  return items;
};

// -------------------------- BREAD CRUMB --------------------------
// -------------------------- MENU --------------------------
export const setMenuItem = (props) => {
  if (props?.title) {
    const { title, url, key, arrow, icon, children } = props;
    const href = url;
    let label = href ? (
      <>
        <a href={href} target="_self" rel="noopener noreferrer">
          {title}
        </a>
        {arrow ? (
          <BsChevronDown
            style={{ fontSize: 10, marginLeft: 5 }}
            className="arrow-down"
          />
        ) : null}
      </>
    ) : (
      title
    );
    return { key, children, label, icon };
  }
  return null;
};

export const newMenus = (items) => {
  const menu = [
    setMenuItem({ ...items?.dashboard }),
    setMenuItem({ ...items?.wallet }),

    setMenuItem({ ...items?.system }),
  ];
  return menu;
};

export const newAuthMenu = (items, logged) => {
  const loggedin = [setMenuItem({ ...items?.account })];
  const anonymous = [
    setMenuItem({ ...items?.register }),
    setMenuItem({ ...items?.login }),
  ];
  const menu = logged === null ? [] : logged === true ? loggedin : anonymous;
  return menu;
};

export const newDashboard = (items) => {
  const operator = [items?.operators];
  const concepts = [items?.concepts, items?.approves];
  const news = [items?.newsCategory, items?.newsPost];
  const three = [items?.threeMapperListing, items?.threeMapperBrand];
  return {
    operator,
    concepts,
    news,
    three,
  };
};
